import { AuthRightColumn } from '@/components/SlimHeader';
import { Flex } from '@/ui';

export const AppHeaderActions = () => (
  <Flex align="center" gap={{ base: 1.5, md: 3 }}>
    <AuthRightColumn buttonProps={{ width: { md: 'auto' } }} isCompact />
  </Flex>
);
